<div class="card-with-shadow bg-white p-2 col-span-3 col-start-2">
  <div *ngIf="chart" [chart]="chart"></div>
</div>
